<template>
  <div class="header__wrapper">
    <a href="https://nki.gov.hu" class="link">
      <img src="../../../public/nki_hun_white.png" class="nki-logo__big" alt="NKI Logo" />
      <img src="../../../public/logo.svg" alt="NKI Logo small" class="nki-logo__small" />
    </a>
    <h1>
      {{ $t('pageTitle') }}
    </h1>
    <div class="nbsz-logo__link link">
      <a href="https://nbsz.gov.hu">
        <img src="../../../public/nbsz_white.png" alt="NBSZ Logo" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeaderContainer'
};
</script>

<style lang="scss" scoped>
@import 'Plugins/style/breakpoints';

.header__wrapper {
  padding: 1em 1em 0 1em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .nbsz-logo__link {
    width: 115px;
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
  }

  .nki-logo__big {
    display: none;
  }
  img {
    height: 50px;
  }

  .timer {
    padding: 0 1em;
    font-size: 1em;
    pointer-events: none;
    user-select: none;
  }

  h1 {
    display: inline-block;
    width: 100%;
    margin: 0;
    font-size: 1.1em;
    text-align: center;
    padding-left: 1em;
  }
}

@media (min-width: $phone) and (max-width: $tablet) {
}

@media (min-width: $tablet) and (max-width: $desktop) {
  .header__wrapper {
    .timer {
      font-size: 1.8em;
    }

    .nki-logo__big {
      display: unset;
    }
    .nki-logo__small {
      display: none;
    }

    h1 {
      font-size: 1.4em;
      padding: 0;
    }
  }
}

@media (min-width: $desktop) {
  .header__wrapper {
    position: relative;
    .timer {
      display: block;
      width: 100%;
      font-size: 2em;
    }
    img {
      height: 75px;
    }
    .link {
      position: absolute;
      top: 1em;
      z-index: 100;
      &.nbsz-logo__link {
        right: 1em;
      }
    }

    .nki-logo__big {
      display: unset;
    }
    .nki-logo__small {
      display: none;
    }

    h1 {
      font-size: 1.6em;
      padding: 0;
    }
  }
}
</style>
